import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

export const RegionSchema = z.object({
    id: z.string().uuid(),
    name: z.string().max(255),
    slug: z.string().max(255).nullable().optional(),
    is_active: z.boolean().or(z.number()), // API might return boolean or 1/0
    created_at: z.string(),
    updated_at: z.string(),
});

export const IndexRegionsResponse = BaseResponseSchema.extend({
    data: z.array(RegionSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export const ShowRegionResponse = BaseResponseSchema.extend({
    data: RegionSchema,
});

export type RegionType = z.infer<typeof RegionSchema>;
export type IndexRegionsResponseType = z.infer<typeof IndexRegionsResponse>;
export type ShowRegionResponseType = z.infer<typeof ShowRegionResponse>;
